var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['app-root']},[_c('RouterView'),(_vm.isValidating)?_c('div',{class:_vm.$style['loading-spinner']},[_c('Spinner')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }